<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon';

    export default UiIcon;
</script>

